import {InjectionToken} from '@angular/core';
import {ExceptionHandlerService} from '../services/exception-handler-service';

// used to inject the exception handlers into the ExceptionDispatcherService in the app.config.ts
export const EXCEPTION_HANDLER_TOKEN = new InjectionToken<ExceptionHandlerService[]>('EXCEPTION_HANDLER_TOKEN');
